<template>
	<vue-chart
		type="bar"
		:data="barData"
		:options="optionsChart"
		class="report-container"
	></vue-chart>
</template>

<script>
import VueChart from 'vuechart';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// function average(newAverage) {
// 	this.barData.datasets[0].data = [...newAverage];
// }

function labels(newLabels) {
	// this.barData.labels = [...newLabels];
	this.barData.labels = newLabels.map(() => '');
}

function percentage(newPercentage) {
	this.barData.datasets[0].data = [...newPercentage];
	this.barData.datasets[0].backgroundColor = [...Array(newPercentage.length || 0)].map(() => '#5ed52b');
}

function data() {
	return {
		barData: {
			datasets: [
				// {
				// 	data: ['10', '30', '30', '40', '10', '10', '30', '40'],
				// 	type: 'line',
				// 	fill: false,
				// 	data: [],
				// backgroundColor: ['#545a54', '#545a54', '#545a54',
				// '#545a54', '#545a54', '#545a54', '#545a54', '#545a54'],
				// },
				{
					// data: ['20', '40', '30', '40', '10', '10', '30', '40'],
					data: [],
					backgroundColor: [],
				},
			],
			labels: ['', '', '', '', '', '', '', ''],
		},
		optionsChart: {
			responsive: true,
			legend: {
				display: false,
			},
			scales: {
				yAxes: [
					{
						ticks: {
							beginAtZero: true,
							min: 0,
							max: 100,
							tepSize: 25,
							padding: 14,
							fontColor: '#487fff',
							fontStyle: 'bold',
						},
						gridLines: {
							color: '#e7e7e7',
							display: true,
							drawBorder: false,
							zeroLineColor: '#487fff',
							zeroLineWidth: 2,
						},
						position: 'right',
					},
				],
				xAxes: [
					{
						categoryPercentage: 0.8,
						barPercentage: 0.3,
						gridLines: {
							display: false,
						},
					},
				],
			},
			tooltips: {
				enabled: false,
			},
			plugins: {
				datalabels: {
					color: '#487fff',
					anchor: 'end',
					align: 'top',
					font: {
						weight: 'bold',
					},
					formatter: (value, context) => {
						const index = context.datasetIndex;
						return index === 0 ? `${value}%` : value;
					},
				},
			},
		},
	};
}

export default {
	name: 'card-chart',
	components: {
		[VueChart.name]: VueChart,
	},
	data,
	props: {
		average: {
			default: () => [],
			type: Array,
		},
		labels: {
			default: () => [],
			type: Array,
		},
		percentage: {
			default: () => [],
			type: Array,
		},
	},
	plugins: [ChartDataLabels],
	mounted() {
		// overriding chart container
		const reportContainer = document.getElementsByClassName('report-container')[0];
		reportContainer.style.height = 'auto';
	},
	watch: {
		// average,
		labels,
		percentage,
	},
};
</script>
<style lang="scss">
	.report-container > div {
		position: relative !important;
	}
</style>





// WEBPACK FOOTER //
// src/components/diagnosis/card-chart.vue